module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Liestal-8a13ad9f36e94adac6780dfe579037ec.svg";